const isCypress = typeof window.Cypress !== 'undefined';

// Makes nuxt context accessible in cypress via the window object
export default (context) => {
  if (isCypress) {
    window.nuxtApp = context;
  }
};
